var BufferListBufferView = require('bufferlistbufferview');


var BufferListChildView = BufferListBufferView.extend({
    tagName: 'li',
    className: 'buffer',
    attributes: {
        'role': 'presentation'
    },
    render: function () {
        BufferListBufferView.prototype.render.call(this);
        this.model.bind('urlChange', this.renderLinkUrl, this);
        this.model.bind('change:name', this.renderLinkText, this);
        this.listenTo(this.model.session.pinnedBuffers, 'change', this.renderLinkText);
        this.listenTo(this.model.session.pinnedBuffers, 'fullChange', this.renderLinkText);

        this.model.bind('moveSegment', this.remove, this);
        
        return this;
    },
    renderLinkUrl: function () {
        this.link.attr('href', this.model.url());
        return this;
    },
    renderLinkText: function () {
        var displayName = this.model.getDisambiguatedListName();
        this.link.attr('title', this.model.getDisplayNameWithConnection());
        this.setLinkLabelHtml(this.formatter.render(displayName));
        return this;
    }
});


module.exports = BufferListChildView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistchildview.js
// module id = 1ka6
// module chunks = 1